import PendingInvoiceItem from '~/types/PendingInvoiceItem';
import { ActionKeys } from './constants';

export function fetchPendingInvoiceTransactions(queryParams?: {
  pageNumber?: number;
  pageSize?: number;
}) {
  return <const>{
    type: ActionKeys.INVOICE_TRANSACTIONS_PENDING_FETCH,
    payload: {
      ...queryParams,
    },
  };
}

export function fetchPendingInvoiceTransactionsSuccess(
  transactionList: PendingInvoiceItem[],
  pageCount: number,
) {
  return <const>{
    type: ActionKeys.INVOICE_TRANSACTIONS_PENDING_FETCH_SUCCESS,
    payload: {
      transactionList,
      pageCount,
    },
  };
}

export function fetchPendingInvoiceTransactionsError(error) {
  return <const>{
    type: ActionKeys.INVOICE_TRANSACTIONS_PENDING_FETCH_ERROR,
    payload: {
      error,
    },
  };
}

export type PendingInvoiceTransactionsActions =
  | ReturnType<typeof fetchPendingInvoiceTransactions>
  | ReturnType<typeof fetchPendingInvoiceTransactionsSuccess>
  | ReturnType<typeof fetchPendingInvoiceTransactionsError>;
